(function() { window.GUID_83637339_42f7_4cee_9974_14b47804731c = { getGuid: function() { return "83637339-42f7-4cee-9974-14b47804731c"; } }; })();
var CS;
(function (CS) {
    var Cookie;
    (function (Cookie) {
        let Names;
        (function (Names) {
            let UI;
            (function (UI) {
                UI.ShouldKeepBracketDrawerOpen = "ShouldKeepBracketDrawerOpen";
            })(UI = Names.UI || (Names.UI = {}));
            let Notifications;
            (function (Notifications) {
                Notifications.MatchCardHistoryNotification = "mch_notif";
            })(Notifications = Names.Notifications || (Names.Notifications = {}));
            let Features;
            (function (Features) {
                Features.PricingUpdate = "pricingUpdate";
            })(Features = Names.Features || (Names.Features = {}));
            function getMatchCardNotificationName(contentHash) {
                return `${Notifications.MatchCardHistoryNotification}_${contentHash}`;
            }
            Names.getMatchCardNotificationName = getMatchCardNotificationName;
        })(Names = Cookie.Names || (Cookie.Names = {}));
    })(Cookie = CS.Cookie || (CS.Cookie = {}));
})(CS || (CS = {}));

//# sourceMappingURL=cs-cookie-names.js.map
